import { HTMLProps } from 'react';

import clsx from 'clsx';

export enum GMFieldStyles {
  MAIN = 'main',
  DAYS = 'days',
}

type GMFieldProps = HTMLProps<HTMLDivElement> & {
  gmData: number;
  styleType: GMFieldStyles;
};

const GMFieldDescriptions = [
  'спокойное',
  'слабовозмущенное',
  'слабовозмущенное',
  'возмущенное',
  'буря',
  'буря',
  'сильная буря',
  'сильная буря',
  'шторм',
];

const GMField = ({ gmData, className, styleType }: GMFieldProps) => {
  if (styleType === GMFieldStyles.MAIN) {
    return (
      <div className={clsx('flex items-baseline text-grey-800 dark:text-blue-grey-200', className)}>
        <span className="text-sm lg:hidden">Г/м поле</span>
        <span className="hidden text-base lg:inline">Магнитное поле</span>
        <span
          className={clsx(
            'ml-2 text-sm font-medium lg:text-base lg:font-normal lg:leading-relaxed xl:text-xl',
            gmData > 4 ? 'text-red dark:text-red' : 'text-grey-900 dark:text-white'
          )}
        >
          {gmData}
        </span>
        <span className="ml-1 text-xs dark:text-blue-grey-500 lg:text-sm">из 9</span>
      </div>
    );
  }

  return (
    <div className={clsx('flex items-baseline', className)}>
      <span className="text-xs font-medium text-blue-grey-500 lg:text-sm">Магнитное поле</span>
      <span
        className={clsx(
          'ml-2 text-sm font-medium lg:ml-2.5 lg:text-base xl:text-lg',
          gmData > 4 ? 'text-red' : 'text-grey-900'
        )}
      >
        {gmData}
      </span>
      <span className="ml-1 text-xs font-medium text-grey-800 xl:text-base">
        из 9 {gmData > 0 && <span>({GMFieldDescriptions[gmData - 1]})</span>}
      </span>
    </div>
  );
};

export default GMField;
